import * as React from "react";
import { ArchiveIcon } from "@radix-ui/react-icons";
import { ItemCard, isCardShaped } from "../common/items/ItemCard.tsx";
import { UnreadItemDoc } from "@repo/convex/convex/schema.ts";
import { ItemMenu } from "../common/items/ItemMenu.tsx";
import { TrashItemMenuItem } from "../common/items/menu/TrashItemMenuItem.tsx";
import { CommonMenuItems } from "../common/items/menu/CommonMenuItems.tsx";
import { ListedItem } from "@repo/convex/convex/items.ts";
import { CardIconButton, ItemActions } from "../common/items/ItemActions.tsx";
import { ItemNotesActionButton } from "../common/items/ItemNotesActionButton.tsx";
import { useCommonDialogs } from "../common/CommonDialogsProvider.tsx";
import { ItemChatActionButton } from "../common/items/ItemChatActionButton.tsx";

interface Props {
  item: ListedItem<UnreadItemDoc>;
}

// Videos and posts have room for notes as well as archive, as in the app. An article's line is
// busier, so it only has notes once it has some (they're in its menu otherwise).
export const StashItem: React.FC<Props> = ({ item }) => {
  const dialogs = useCommonDialogs();

  return (
    <ItemCard
      item={item}
      actions={
        <ItemActions>
          {item.hasNotes || isCardShaped(item) ? <ItemNotesActionButton itemId={item._id} /> : null}
          {item.hasChat ? <ItemChatActionButton itemId={item._id} /> : null}
          <CardIconButton
            label="Archive"
            onClick={() => dialogs?.openPostArchive({ itemId: item._id })}
          >
            <ArchiveIcon />
          </CardIconButton>
        </ItemActions>
      }
      menu={
        <ItemMenu>
          <CommonMenuItems item={item} />
          <TrashItemMenuItem item={item} />
        </ItemMenu>
      }
    />
  );
};
